import { useState } from "react"
import { StepDamageTag } from "@/components/estimates/quick-estimate/damage-tag/step-damage-tag"
import { StepGuidedPhotos } from "@/components/estimates/quick-estimate/step-guided-photos"
import {
  newTagFromPanel,
  PANELS_BY_ID,
  type DamageTag,
  type PanelSpec,
} from "@/components/estimates/quick-estimate/damage-tag/panels"
import type { UseQECapture } from "@/components/estimates/quick-estimate/use-qe-capture"
import type { QuickEstimateActions } from "@/components/estimates/quick-estimate/use-quick-estimate-state"

// TEMP review-only route (/dev-3d) for the 3D tagger + guided photos.
// Not committed / not shipped — lets the designer eyeball the components
// without logging in and walking the full /quick wizard.
const stubCapture: UseQECapture = {
  fileInputRef: { current: null },
  inflight: [],
  retryingId: null,
  hasFileRef: () => false,
  triggerCapture: () => {},
  handleFile: async () => {},
  handleRetry: async () => {},
  forgetFile: () => {},
  setCaptureContext: () => {},
}
const stubActions = { removePhoto: () => {} } as unknown as QuickEstimateActions
const mockTags: DamageTag[] = [
  newTagFromPanel(PANELS_BY_ID["front-bumper"]),
  newTagFromPanel(PANELS_BY_ID["hood"]),
  newTagFromPanel(PANELS_BY_ID["front-door-left"]),
]

export default function Dev3DTaggerPage() {
  const [tags, setTags] = useState<DamageTag[]>([])
  return (
    <div className="min-h-screen space-y-8 bg-gradient-to-b from-zinc-50 to-white py-8">
      <div className="mx-auto max-w-[640px] px-4">
        <div className="rounded-3xl border border-zinc-200/70 bg-white p-5 shadow-2xl shadow-zinc-900/[0.07] md:p-10">
          <StepDamageTag
            tags={tags}
            onTogglePanel={(p: PanelSpec) =>
              setTags((ts) =>
                ts.some((t) => t.panelId === p.id)
                  ? ts.filter((t) => t.panelId !== p.id)
                  : [...ts, newTagFromPanel(p)],
              )
            }
            onRemove={(id) => setTags((ts) => ts.filter((t) => t.panelId !== id))}
            onUpdateTag={(id, patch) =>
              setTags((ts) =>
                ts.map((t) => (t.panelId === id ? { ...t, ...patch } : t)),
              )
            }
            onContinue={() => {}}
          />
        </div>
      </div>

      {/* Guided photos preview (mock tags + stub capture) */}
      <div className="mx-auto max-w-[640px] px-4">
        <div className="rounded-3xl border border-zinc-200/70 bg-white p-5 shadow-2xl shadow-zinc-900/[0.07] md:p-10">
          <StepGuidedPhotos
            damageTags={mockTags}
            photos={[]}
            actions={stubActions}
            capture={stubCapture}
            onBack={() => {}}
            onContinue={() => {}}
          />
        </div>
      </div>
    </div>
  )
}
